import { api } from './http';
import type {
  DesktopTimekeeperDownload,
  TimeEntry,
  TimekeepingStatus,
  TodayEntries,
} from './types';

export const getTimekeepingStatus = () =>
  api.get<TimekeepingStatus>('/timekeeping/status').then(r => r.data);

export const getDesktopTimekeeperWindowsDownload = () =>
  api.get<DesktopTimekeeperDownload>('/desktop-timekeeper/download/windows').then(r => r.data);

export const getRunningTimer = () =>
  api.get<TimeEntry | null>('/timekeeping/running').then(r => r.data);

export const startTimer = (data: {
  matter_id: number;
  description?: string;
  activity_category?: string;
  billable?: boolean;
}) =>
  api.post<TimeEntry>('/timekeeping/timer/start', data).then(r => r.data);

export const stopTimer = () =>
  api.post<{ id: number; duration_seconds: number; matter_id: number }>('/timekeeping/timer/stop').then(r => r.data);

export const getTodayEntries = (date?: string) =>
  api.get<TodayEntries>('/timekeeping/today', { params: date ? { date } : {} }).then(r => r.data);

export const getMatterTimeEntries = (matterId: number) =>
  api.get<TimeEntry[]>(`/timekeeping/matters/${matterId}/time-entries`).then(r => r.data);

export const createTimeEntry = (data: {
  matter_id: number;
  description?: string;
  duration_seconds?: number;
  start_time?: string;
  end_time?: string;
  entry_date?: string;
  activity_category?: string;
  billable?: boolean;
  rate_cents?: number;
}) =>
  api.post<TimeEntry>('/timekeeping/time-entries', data).then(r => r.data);

export const updateTimeEntry = (entryId: number, data: {
  matter_id?: number;
  description?: string;
  duration_seconds?: number;
  start_time?: string;
  end_time?: string;
  entry_date?: string;
  activity_category?: string;
  billable?: boolean;
  rate_cents?: number;
}) =>
  api.patch<TimeEntry>(`/timekeeping/time-entries/${entryId}`, data).then(r => r.data);

export const deleteTimeEntry = (entryId: number) =>
  api.delete(`/timekeeping/time-entries/${entryId}`);
